module.exports = __webpack_public_path__ + "assets/fbc6c8bb350f5884a3ccb32eabadf1f2.mp3";